import { CREATE_RESET_REQUEST } from '../constants/reset-request';

export function createResetRequest(itemType, itemId) {
  return {
    type: CREATE_RESET_REQUEST,
    api: true,
    auth: true,
    payload: {
      method: 'POST',
      url: '/students/reset-requests',
      data: { itemType, itemId }
    }
  };
}
